import React from 'react';
import rejectedPaymentImg from '../assets/images/icon/pagorechazado.gif'

function RejectedPayment({ urlRedirect }) {
  return (
    <div className="w-full flex flex-col items-center justify-center text-center lg:pl-[85px] lg:pr-[85px]">
        <img
            src={rejectedPaymentImg} alt="rejected"
            className="w-60 sm:w-52 md:w-80 lg:w-80 lg:h-80 object-contain"
        />

        <h1 className="text-red-600 font-bold text-3xl mb-2 sm:text-4xl md:text-4xl lg:text-4xl -pt-[300px]">
            ¡Pago rechazado!
        </h1>
        <h2 className="text-gray-700 font-medium text-lg sm:text-xl mt-2">
            Te invitamos a seleccionar otra forma de pago
        </h2>

        <h3 className="text-gray-600 text-sm sm:text-base mt-[25px] pb-2">
            En 5 segundos automáticamente cambiará la página, si no lo hace, da clic{' '}
            <a id="urlRedirect" href={urlRedirect} className="text-[#B6BF00] font-semibold underline">
                aquí
            </a>
        </h3>
    </div>
  );
}

export default RejectedPayment;
